import { render } from "./AuthorList.vue?vue&type=template&id=52b87aca"
import script from "./AuthorList.vue?vue&type=script&lang=js"
export * from "./AuthorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Terms/AuthorList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52b87aca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52b87aca', __exports__)) {
    api.reload('52b87aca', __exports__)
  }
  
  module.hot.accept("./AuthorList.vue?vue&type=template&id=52b87aca", () => {
    api.rerender('52b87aca', render)
  })

}


export default __exports__